"use client";

import React, { useRef } from "react";
import dynamic from "next/dynamic";

// components
import LoliveBanner from "../containers/LoliveBanner";
import QuickSearch from "../containers/QuickSearch";
const HomeBrands = dynamic(() => import("@/components/HomeBrands"), { ssr: false });
const BriefUs = dynamic(() => import("../containers/BriefUs"), { ssr: false });
const LoliveSlider = dynamic(() => import("../components/LoliveSlider"), { ssr: false });
import TreadingLocationSlide from "../components/TreadingLocationSlide";

// interfaces
import { ILolivePage } from "./ILolivePage";
import { TreadingLocationSlideProps } from "../components/TreadingLocationSlide/ITreadingLocationSlide";

// helpers
import { useDimension } from "@/hooks/useDimensions";
import { getQueryFromLink } from "@/containers/PopularDestinations/helpers";

// assets
import styles from "@/assets/styles/pages/lolive/index.module.scss";


function LoLivePage(props: ILolivePage) {
  const {
    popularDestinations,
    environments,
    treadingLocations,
    brandLogos,
    localizationCode
  } = props;

  const quickSearchRef = useRef<HTMLElement>(null);

  const { title, locations } = treadingLocations[0] || {};
  const popularDestinationsToUse = popularDestinations.map((item) => ({
    value: item.image,
    label: item.name,
    href: `/search-results${getQueryFromLink(item.link)}`
  })).filter((item) => item.value);
  const environmentsToUse = environments
    .sort((current, next) => current.position - next.position)
    .map((item) => ({
      value: item.image,
      label: item.name,
      href: `/search-results?ordering=-high_to_low&offset=0&collections__in=${item.typeOfLocation}&except_facet=collection&environments=true`
    })).filter((item) => item.value);

  const [width] = useDimension();

  const isTablet = width < 1200;
  const isMobile = width < 820;

  const responsiveSlidesPerView = isTablet && !isMobile ? 4 : 2;
  const slidesPerView = !isTablet && !isMobile ? 6 : responsiveSlidesPerView;
  const responsiveSlidesPerViewBig = isTablet && !isMobile ? 3 : 2;
  const sliderPerViewBig = !isTablet && !isMobile ? 4 : responsiveSlidesPerViewBig;

  // methods
  const handleScrollToQuickSearch = () => {
    if (quickSearchRef.current) {
      quickSearchRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  // renders
  return (
    <>
      <LoliveBanner
        onScroll={handleScrollToQuickSearch}
        src={localizationCode === "aus"
          ? "https://d2gfhx6otln0v7.cloudfront.net/media/images/lolive-aus-landing-page.mp4"
          : "https://d2gfhx6otln0v7.cloudfront.net/media/images/landing_lolive_v2_13_10_23.mp4"
        }
      />
      <QuickSearch
        ref={quickSearchRef}
        popularDestinations={popularDestinationsToUse}
      />
      <div className={styles["locl-lolive-page__sliders"]}>
        <BriefUs />
        <div className={styles["locl-lolive-page__sliders-treading"]}>
          <LoliveSlider
            title={title}
            items={locations}
            renderSlide={(item) => <TreadingLocationSlide { ...item as TreadingLocationSlideProps } />}
            slidesPerView={sliderPerViewBig}
            isMobileView={isMobile}
            data-testid="locl-lolive-page-sliders-treading"
          />
        </div>
        <LoliveSlider
          title="Popular Destinations"
          items={popularDestinationsToUse}
          slidesPerView={slidesPerView}
          isMobileView={isMobile}
          data-testid="locl-lolive-page-sliders-destination"
        />
        <LoliveSlider
          title="Environments"
          items={environmentsToUse}
          slidesPerView={slidesPerView}
          isMobileView={isMobile}
          data-testid="locl-lolive-page-sliders-environments"
        />
      </div>
      <HomeBrands customBrands={brandLogos} filterColor="rgba(243, 244, 246, 1)" />
    </>
  );
}

export default LoLivePage;
